import { render, staticRenderFns } from "./monthPlanSummary.vue?vue&type=template&id=6b48d7f8&scoped=true&"
import script from "./monthPlanSummary.vue?vue&type=script&lang=js&"
export * from "./monthPlanSummary.vue?vue&type=script&lang=js&"
import style0 from "./monthPlanSummary.vue?vue&type=style&index=0&id=6b48d7f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48d7f8",
  null
  
)

export default component.exports